export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';